/**
 * CSS variables used for theming in the application
 */
export default {
    COLOR_BG_PAGE: 'colorBgPage',
    COLOR_BG_BUTTON: 'colorBgButton',
    COLOR_BG_PRIMARY: 'colorBgPrimary',
    COLOR_TEXT_PRICE: 'colorTextPrice',
    COLOR_TEXT_MUTED: 'colorTextMuted',
    BORDER_MENU_ITEM: 'borderMenuItem',
    COLOR_TEXT_ACCENT: 'colorTextAccent',
    COLOR_TEXT_BUTTON: 'colorTextButton',
    COLOR_BG_SECONDARY: 'colorBgSecondary',
    COLOR_BG_BRAND_PAGE: 'colorBgBrandPage',
    COLOR_TEXT_HEADING: 'colorTextHeading',
    COLOR_TEXT_PRIMARY: 'colorTextPrimary',
    COLOR_TEXT_ITEM_BODY: 'colorTextItemBody',
    COLOR_BG_PAGE_DARKER: 'colorBgPageDarker',
    BORDER_SELECTED_ITEM: 'borderSelectedItem',
    COLOR_TEXT_SECONDARY: 'colorTextSecondary',
    COLOR_BG_BRAND_BANNER: 'colorBgBrandBanner',
    COLOR_TEXT_SUBHEADING: 'colorTextSubheading',
    BORDER_BUTTON_PRIMARY: 'borderButtonPrimary',
    COLOR_HIGHLIGHT_BORDER: 'colorHighlightBorder',
    BORDER_BOTTOM_MENU_ITEM: 'borderBottomMenuItem',
    COLOR_TEXT_BRAND_BANNER: 'colorTextBrandBanner',
    COLOR_SECONDARY_ACTIONS: 'colorSecondaryActions',
    COLOR_BG_MODAL_OVERLAY: 'colorBgModalOverlay',
    COLOR_BG_SECONDARY_TRANSPARENT: 'colorBgSecondaryTransparent',
    COLOR_BG_MODIFIER_CARD: 'colorBgModifierCard',
    COLOR_BG_SELECTED_MODIFIER_CARD: 'colorBgSelectedModifierCard',
    BOX_SHADOW_MODIFIER_CARD: 'boxShadowModifierCard',
    COLOR_BG_QUICK_ADD: 'colorBgQuickAdd',
    COLOR_TEXT_QUICK_ADD: 'colorTextQuickAdd',

    MENU_ITEM_WIDTH: 'menuItemWidth',
    BOX_SHADOW_MENU_ITEM: 'boxShadowMenuItem',
    BODY_TEXT_TRANSFORM: 'bodyTextTransform',
    LINE_CLAMP_MENU_ITEM: 'lineClampMenuItem',
    ACCENT_TEXT_TRANSFORM: 'accentTextTransform',
    HEADING_TEXT_TRANSFORM: 'headingTextTransform',
    MENU_LIST_ITEM_FLEX_DIRECTION: 'menuListItemFlexDirection',
    MENU_LIST_ITEM_JUSTIFY: 'menuListItemJustify',
    MENU_LIST_GRID_COLS_DESKTOP: 'menuListGridColsDesktop',
    MENU_LIST_GRID_COLS_MOBILE: 'menuListGridColsMobile',
    MENU_BG_IMAGE: 'menuBgImage',

    HEADING_FONT_SIZE_MULTIPLIER: 'headingFontSizeMultiplier',
    BODY_FONT_SIZE_MULTIPLIER: 'bodyFontSizeMultiplier',

    BUTTON_FONT: 'buttonFont',
    CLIP_PATH_BUTTON: 'clipPathButton',
    BORDER_RADIUS_BUTTON: 'borderRadiusButton',
    MODAL_BORDER: 'modalBorder'
};
